import styles from "./Footer.module.css";
import { navLinks } from "../../data/nav";
import { siteConfig } from "../../siteConfig";
import logo from "../../assets/images/jalaram-ad-logo.png";

export function Footer() {
  return (
    <footer className={`${styles.footer} on-dark`}>
      <div className={`container ${styles.top}`}>
        <div className={styles.brandCol}>
          <img src={logo} alt="Jalaram Ad." className={styles.logo} />
          <p>{siteConfig.description}</p>
        </div>

        <nav className={styles.col} aria-label="Footer navigation">
          <h4>Navigate</h4>
          {navLinks.map((link) => (
            <a key={link.href} href={link.href}>
              {link.label}
            </a>
          ))}
        </nav>

        <div className={styles.col}>
          <h4>Contact</h4>
          <a href={siteConfig.contact.phoneHref}>{siteConfig.contact.phoneDisplay}</a>
          <a href={siteConfig.contact.emailHref}>{siteConfig.contact.email}</a>
          {/* <a href={siteConfig.contact.whatsappHref} target="_blank" rel="noopener noreferrer">
            {siteConfig.contact.whatsappDisplay}
          </a> */}
          <span>
            {siteConfig.location.city}, {siteConfig.location.state}, {siteConfig.location.country}
          </span>
        </div>
      </div>

      <div className="container">
        <div className={styles.bottom}>
          <span>© 2026 Jalaram Ad. All Rights Reserved.</span>
        </div>
      </div>
    </footer>
  );
}
